/*
HOW TO
MAKE IMAGE ARRAY AND PASS TO preload.startLoad
------------------------------------------------
var imgarry = [];
for(var i = 0; i < 100; i++){
	imgarry.push("images/test/bg" + i + ".png");
}
preload.startLoad(100,imgarry).done(function(){
	console.log("all done")
});
*/

var preload = {
	count: 0,
	max : 0,
	arry: [],
	startLoad: function(max,arry){
		var defer = $.Deferred();
		preload.count = 0;
		this.max = max;
		this.arry = arry;
		var promise = this.load();

		promise.done(function(){
			defer.resolve();
		});
		return defer.promise();
	},
	reset: function(){
		preload.count = 0;
		$(".cover_r .blk").css("transform", "rotate(0deg)");
		$(".cover_l .blk").css("transform", "rotate(0deg)");
		$("#loading p span").removeClass();
	},
	load: function(){
		var defer 	= $.Deferred();
		loadImg();

		function loadImg(){
			var newImg = new Image();
			newImg.src = preload.arry[preload.count];
			newImg.onload = function(){
				preload.count++;
				var per = Math.floor((preload.count/preload.max)*0.87*100);
				var pers = String(per).split("");
				if(pers.length === 1){
					var f = 0;
					var s = pers[0];
				}else{
					var f = pers[0];
					var s = pers[1];
				}
				
				if(per <= 50){
					$(".cover_r .blk").css("transform", "rotate(" + (180/50)*per + "deg)");
				}else{
					$(".cover_r .blk").css("transform", "rotate(180deg)");
					$(".cover_l .blk").css("transform", "rotate(" + (180/50)*(per-50) + "deg)");
				}
				$("#loading p span").removeClass();
				$("#loading p span").eq(0).addClass("n" + f);
				$("#loading p span").eq(1).addClass("n" + s);
				if(preload.count < preload.max){
					setTimeout(function(){
						loadImg();
					},33);
				}else{
					$(".cover_l .blk").css("transform", "rotate(180deg)");
					setTimeout(function(){
						$("#loading").addClass("big");
						setTimeout(function(){
							$("#loading").addClass("hide");
							defer.resolve();
						},400);
					},200);
				}
			}
		}
		return defer.promise();
	}
}
var btm = {
	init: function(){
		var s0 = $("footer h6 span").eq(0),
			s1 = $("footer h6 span").eq(1);
		var count = 0,
			max = 87,
			duration = 1000,
			rad = Math.PI/180;
		$("footer a").off().on("click", function(){
			$(this).addClass("countup");
			count = 0;
			max = 87;
			duration = 33;
			s0.removeClass().addClass("n0");
			s1.removeClass().addClass("n0");
			countUp();
		});
		function countUp(){
			count++;
			duration = 100 - Math.sin(rad*count)*200;
			var per = Math.ceil((count/max)*0.87*100);
			var pers = String(per).split("");
			if(pers.length === 1){
				var f = 0;
				var s = pers[0];
			}else{
				var f = pers[0];
				var s = pers[1];
			}
			$("footer h6 span").removeClass();
			s0.addClass("n" + f);
			s1.addClass("n" + s);
			if(parseInt(per) < 87){
				setTimeout(function(){
					countUp();
				},duration);
			}else{
				common.scrollToPosition(0,1000);
				setTimeout(function(){
					$("footer a").removeClass("countup");
				},300);
			}
		}
	}
}